export const APP_VERSION = "1.1.2";
export const US_AUTOCOMPLETE_PRO_API_URL = "https://us-autocomplete-pro.api.smarty.com/lookup";
export const INTERNATIONAL_AUTOCOMPLETE_API_URL =
	"https://international-autocomplete.api.smarty.com/v2/lookup";

export const US_COUNTRY_CODES = ["US", "USA"];
